import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CourseService } from '@app/_services/course.service';
import { first } from 'rxjs/operators';

@Component({ selector: 'peb-results', templateUrl: 'peb-results.component.html' })
export class PEBResultsComponent {

    @Input() course: any;

    assessmentResultText: string;
    answers: any;

    resultTitle: string;
    resultText: string;

    constructor(private courseService: CourseService, private router: Router) { }

    ngOnInit() {
        this.assessmentResultText = "SPROUTING";
        this.getAssessmentAnswers();

    }

    getAssessmentAnswers() {
        this.courseService.getAssessmentAnswers().pipe(first()).subscribe(data => {
            this.answers = [];
            data.map(d => {
                let value = 1;
                if (d.answer.answer == "Sprouting") {
                    value = 1.6;
                }
                if (d.answer.answer == "Blooming") {
                    value = 2.3;
                }
                if (d.answer.answer == "Full Bloom") {
                    value = 3;
                }

                let key = d.order;
                let answer = { [key]: value };
                this.answers.push(value);
            })

            let answersValues = this.answers;

            let value1 = 1;
            let value16 = 1.6;
            let value23 = 2.3;
            let value3 = 3;

            let value1Count = { length: answersValues.filter((v) => (v === value1)).length, value: 1 };
            let value16Count = { length: answersValues.filter((v) => (v === value16)).length, value: 1.6 };
            let value23Count = { length: answersValues.filter((v) => (v === value23)).length, value: 2.3 };
            let value3Count = { length: answersValues.filter((v) => (v === value3)).length, value: 3 };

            let mostAppearedValue = [value1Count, value16Count, value23Count, value3Count].sort((one, two) => (one.length > two.length ? -1 : 1))[0];

            switch (mostAppearedValue.value) {
                case 1:
                    this.resultTitle = 'Seeding';
                    this.resultText = "<p>It’s an exciting time for you. You are just starting out on your equity journey. </p><p>You will begin to learn more about you, and how equity applies to your life and work.</p>";
                    break;
                case 1.6:
                    this.resultTitle = 'Sprouting';
                    this.resultText = "You’re on your way! You have an awareness of what is needed to practice equity, and you’re ready to begin.";
                    break;
                case 2.3:
                    this.resultTitle = 'Blooming';
                    this.resultText = "<p>You’re nearly there! You’ve decided that equity is important and have started to implement equitable practices. </p><p>You may be wondering where to go from here and what other practices you might incorporate.</p>"
                    break;
                case 3:
                    this.resultTitle = 'Full Bloom';
                    this.resultText = "<p>You’ve really blossomed! Equity is very important to you because it shows in how you run your company and live your life.</p><p>Now, you’re ready to evaluate the effectiveness of your practices and adapt them. You’re also in a position to determine how to best help other companies and entrepreneurs benefit from what you’ve planted.</p>";
                    break;
            }
        });
    }

    onViewFullResults() {
        this.courseService.getCourse(this.course.courseId).pipe(first()).subscribe(data => {
            this.router.navigate(['/course-section', data.resultsSectionId]);
        });
    }

}